module.exports = __webpack_public_path__ + "img/implement-erp_x.1df65e94.png";